import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

import { VerticalAlign } from "./VerticalAlign";
import { HorizontalAlign } from "./HorizontalAlign";

interface BodyCellProps {
    indent?: number;
    empty?: boolean;
    isGray?: boolean;
    verticalAlignSpec?: VerticalAlign;
    horizontalAlign?: HorizontalAlign;
}

export const BodyCell = styled.td<BodyCellProps>(
    props => ({
        padding: "20px 5px 0 5px",
        fontSize: theme(props).typography.primary.fontSize.css(),
        lineHeight: "22px",
        whiteSpace: "normal",

        verticalAlign: props.verticalAlignSpec,
        textAlign: props.horizontalAlign,
    }),
    props => props.indent != undefined && { paddingLeft: 12 + props.indent * 12 },
    props =>
        props.empty && {
            color: theme(props).typography.inactive.color,
            textAlign: "center",
            lineHeight: "30px",
        },
    props =>
        props.isGray && {
            color: theme(props).typography.secondary.color,
            textAlign: "center",
        }
);

interface HeaderCellProps {
    numbersCell?: boolean;
    indent?: number;
    empty?: boolean;
    isGray?: boolean;
    verticalAlignSpec?: VerticalAlign;
    horizontalAlign?: HorizontalAlign;
}

export const HeaderCell = styled.td<HeaderCellProps>(
    props => ({
        color: theme(props).tables.headers.smallFont.color,
    }),
    props =>
        !props.numbersCell && {
            ...props.theme.candy.tables.headers.smallFont.css(),
            padding: "10px 5px",
            letterSpacing: "0.005em",
            verticalAlign: "bottom",
        },
    props => ({
        verticalAlign: !props.numbersCell ? undefined : props.verticalAlignSpec,
        textAlign: props.horizontalAlign,
    }),
    props =>
        props.empty && {
            textAlign: "center",
            lineHeight: "30px",
        },
    props =>
        props.isGray && {
            textAlign: "center",
        }
);

export const Table = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).tables.border.color,
}));

export const Col = styled.col<{ borderRight?: boolean }>(props => ({
    borderRight: props.borderRight ? theme(props).tables.border.solid : undefined,
}));

export const HorizontalLineRow = styled.tr(props => ({
    padding: 0,
    borderBottom: theme(props).tables.border.solid,
}));

export const HeaderRow = styled.tr<{ numbersRow?: boolean; last?: boolean }>(
    props => ({
        color: theme(props).tables.headers.smallFont.color,
        borderBottom: theme(props).tables.border.solid,
    }),
    props =>
        props.numbersRow && {
            borderBottom: theme(props).tables.border.solid,
            verticalAlign: "middle",
            textAlign: "center",

            [`${HeaderCell}`]: {
                padding: 0,
                lineHeight: "22px",
            },
        },
    props =>
        props.last && {
            td: {
                paddingBottom: 10,
            },
        }
);

export const TextHackElement = styled.span({
    lineHeight: "34px",
});
